// extracted by mini-css-extract-plugin
export default {"timelineComponent":"styles_timelineComponent__p9vZ9","edit":"styles_edit__cU2kK"};